import React from 'react';
import { Link } from 'react-router-dom';

const ProjectCard = ({ id, title, description, image }) => {
  return (
    <div className="bg-white rounded-xl shadow-sm overflow-hidden">
      <div 
        className="h-64 bg-gray-100 bg-cover bg-center" 
        style={{ backgroundImage: image ? `url(${image})` : 'none' }}
      />
      <div className="p-6">
        <h3 className="text-xl font-semibold mb-2">{title}</h3>
        <p className="text-gray-600 mb-4">{description}</p>
        <Link to="/case-study/1" className="text-blue-600 hover:text-blue-700">
      View Case Study →
    </Link>
      </div>
    </div>
  );
};

export default ProjectCard;